export enum OfferWorkflow {
    create = "create",
    edit = "edit",
}

export enum OfferSection {
    offerDetails = "offerDetails",
    configuration = "configuration",
}
